/**
 * directives.utilities Module
 *
 * Description
 */
var app = angular.module('directives.utilities');
app.directive('validateAmount', validateAmount)
app.directive('validateFeedback', validateFeedback)
app.directive('validateCardNumber', validateCardNumber)
app.directive('validateMonth', validateMonth)
app.directive('validateYear', validateYear)
app.directive('validateLogin', validateLogin)
app.directive('validateLoginKe', validateLoginKe)
app.directive('validatePassword', validatePassword)
app.directive('validateEqual', validateEqual)
app.directive('validateSmsCode', validateSmsCode)
app.directive('validateTitle', validateTitle)
app.directive('validateAmountMin', validateAmountMin)
app.directive('zeroReplace', zeroReplace)
app.directive('float', float)
app.directive('meters', meters)
app.directive('metersTest', metersTest)
app.directive('metersValidation', metersValidation)
app.directive('checkAccount', checkAccount)
app.directive('giocCheker', giocCheker)
app.directive('validateTariff', validateTariff)
app.directive('validateValue',validateValue)
app.directive('validateSubsidy',validateSubsidy)

function giocCheker() {

    var obj = {};
    var helper = {
        ctrls: {},
        add: function (name, ctrl) {
            this.ctrls[name] = this.ctrls[name] || [];
            this.ctrls[name].push(ctrl);
        },
        setValidity: function (name, value) {
            this.ctrls[name].forEach(function (ctrl) {
                ctrl.$setValidity('gioc-cheker', value);
            });
        }

    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            if (ctrl.$name === "objectId" || ctrl.$name === "jek" || ctrl.$name === "clientId") {
                ctrl.$validators.giocCheker = function(viewValue) {
                    obj[ctrl.$name] = viewValue;
                    helper.add(attrs.giocCheker, ctrl);

                    if ((obj.objectId || (obj.jek && obj.clientId)) && (obj.objectId && (!obj.jek && !obj.clientId)) || (!obj.objectId && (obj.jek && obj.clientId))) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return true;
            }
        }
    }
}

function checkAccount() {
    var account = '',
        mfo = '';

    var checkAccount = function(account, mfo) {
        account = account.toString();
        mfo = Math.floor(mfo / 10);
        var mfoLength = mfo.toString().length;
        if (!isValidIBAN(account)) {
            var string = mfo + '' + account;
            var array = [];
            for (var i = 0; i < string.length; i++) {
                array.push(string[i]);
            }
            var accountCheckSum = array[(mfoLength + 4)];
            array[mfoLength + 4] = 0;
            var nominal = [
                '1', '3', '7', '1', '3', '3', '7', '1', '3', '7', '1', '3', '7', '1', '3', '7', '1', '3', '7'
            ];
            var result = 0;

            for (i = 0; i < nominal.length; i++) {
                var res = array[i] ? nominal[i] * array[i] : 0;
                result += Number(res.toString().substr(-1));
            }
            result += account.length;
            result = result.toString().substr(-1) * 7;
            result = result.toString().substr(-1);
            return result === accountCheckSum;
        } else {
            return true;
        }
    };

    var isValidIBAN = function(iban) {
        var buffer = 0;
        var charCode;
        var CHAR_CODE_A = 'A'.charCodeAt(0);
        var CHAR_CODE_0 = '0'.charCodeAt(0);
        var isValid = false;

        if (/^UA\d{27}$/.test(iban)) {
            iban = iban.substr(4) + '3010' + iban.substr(2,2);

            for (var i = 0; i < iban.length; ++i) {
                charCode = iban.charCodeAt(i);
                 buffer = charCode + (
                    charCode >= CHAR_CODE_A
                        ? buffer * 100 - CHAR_CODE_A + 10
                        : buffer * 10 - CHAR_CODE_0
                );

                if (buffer > 1000000) {
                    buffer %= 97;
                }
            }

            isValid = (buffer % 97 === 1);
        }

        return isValid;
    }

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {

            ctrl.$validators.checkAccount = function(viewValue) {

                if (ctrl.$name === 'account') {
                    account = viewValue;
                }
                if (ctrl.$name === 'mfo') {
                    mfo = viewValue;
                }
                if (account && mfo) {
                    if (ctrl.$name === 'account') {
                        ctrl.$setValidity('account', checkAccount(account, mfo));
                    }
                    if (ctrl.$name === 'mfo') {
                        ctrl.$setValidity('mfo', checkAccount(account, mfo));
                    }

                    return checkAccount(account, mfo);
                } else {
                    return true;
                }

            }

        }
    }
}


function algorithmMoon(card_number) {
    var arr = [];
    var card_number = String(card_number).replace(/[^\d]/g, '');
    var i = 0;

    if (
        ['4', '5', '6'].indexOf(String(card_number)[0]) === -1 ||
        !/^\d{16}$/.test(card_number)
    ) {
        return false;
    }

    for (; i < card_number.length; i++) {

        if (i % 2 === 0) {
            var m = parseInt(card_number[i]) * 2;
            m > 9 ? arr.push(m - 9) : arr.push(m);
        } else {
            var n = parseInt(card_number[i]);
            arr.push(n);
        }
    }

    var summ = arr.reduce(function(a, b) {
        return a + b;
    });

    return Boolean(!(summ % 10));
}

function metersValidation() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            ctrl.$validators.metersValidation = function(modelV, viewV) {}

        }
    }
}

function meters() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            var regZeroDot = /[0\.]+/;
            var regFloat = /^(?:[1-9]\d{1,3}|0)?(\d{2,5})?$/;
            var regTest = /^[^0](\d{1,5})(.|,)(\d{1,4})/;
            var regFiveNumbers = /^[^0]\d{1,4}$/;

            if (ctrl) {

                ctrl.$validators.meters = function(viewValue) {


                    ctrl.$setValidity(ctrl.$name, !regFiveNumbers.test(viewValue));
                };

            }
        }
    }
}

function metersTest() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            var regZeroDot = /[0\.]+/;
            var regFloat = /^(?:[1-9]\d{1,3}|0)?(\d{2,5})?$/;
            var regTest = /^[^0](\d{1,5})(.|,)(\d{1,4})/;
            var regFiveNumbers = /^[^0]\d{1,4}$/;

            if (ctrl) {

                ctrl.$validators.meters = function(viewValue) {

                    ctrl.$modelValue = viewValue;
                    ctrl.$render();
                    // scope.$apply();

                };

            }
        }
    }
}

function zeroReplace() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            el.bind('keyup change', function() {
                if (angular.isFunction(ctrl.$viewValue.replace)) {
                    ctrl.$setViewValue(ctrl.$viewValue.replace(/[^\d{0,16}(.|,)]/g, "").replace(/^[0]/, ""));
                    ctrl.$render();
                    scope.$apply();
                }
            });
        }
    }
}


function float() {
    var isValid = function(str) {
        // return true;
        var regex = /^(?:[1-9]\d{1,3}|0)?(?:(\.|,)\d{2})?$/;
        return regex.test(str);
    };

    return {
        require: 'ngModel',
        link: function(scope, el, attrs, ngModelCtrl) {

            ngModelCtrl.$parsers.unshift(function(viewValue) {
                var validate = isValid(viewValue);
                ngModelCtrl.$setValidity('float', validate);

                return validate ? parseFloat(viewValue.replace(',', '.')) : null;
            });

            el.bind('keyup change', function() {
                if (angular.isFunction(ngModelCtrl.$viewValue.replace)) {
                    ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue.replace(/[^\d{0,16}(.|,)]/g, "").replace(/^[0]/, ""));
                    ngModelCtrl.$render();
                    scope.$apply();
                }
            });
        }
    };
}

function validateAmountMin() {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            amountMin: '=validateAmountMinValue',
            amountMax: '=validateAmountMaxValue'
        },
        link: postLink
    };

    function postLink(scope, el, attrs, ctrl) {
        ctrl.$validators.validateAmountMin = function(value) {
            if (value) {
                if ((scope.amountMin && +value < +scope.amountMin) || (scope.amountMax && +value > +scope.amountMax)) {
                    return false;
                } else {
                    ctrl.$$parentForm.$setValidity('paymentForm', true);
                    return true;
                }
            }
        }
    }
}


function validateAmount() {
    return {
        // scope:true,       // add
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {

            var regex = new RegExp(/^\d{0,}((\.|,)\d{1,2})?$/);
            var regexNoLetters = /[a-zA-Zа-я-А-Я]/g;
            var re = /^(\d{1,5}[.,]\d{2})[\s\S]*/;

            ctrl.$validators.validateAmount = function(value) {
                if (ctrl.$viewValue == 0) {
                    return false;
                }
                if (value) {
                    var value = value.toString().replace(regexNoLetters, '').replace(',', '.');
                    var result;
                    Number.isInteger = Number.isInteger || function(value) {
                        return typeof value === "number" &&
                               isFinite(value) &&
                               Math.floor(value) === value;
                    };

                    if( parseInt(value) != 0 && Number.isInteger( parseInt(value) ) ){
                        result = value.replace(re, '$1').replace(/^[0]/, "");
                    }else{
                        result = value.replace(re, '$1').replace(/^/, "");
                    }

                    ctrl.$setValidity('amount', true);
                    ctrl.$setViewValue(result);
                    if (!regex.test(result)) {
                        ctrl.$setTouched();
                    }
                    if(scope.pay) {
                        if (scope.pay.service.amount_max != 0 || scope.pay.service.amount_max != null) {                  // added for checking sum size

                            if (result > scope.pay.service.amount_max && scope.pay.service.amount_max != 0 && scope.pay.service.amount_max != null) {    // for limit Max
                                return false;
                            }
                        }
                        if (result < scope.pay.service.amount_min) {      // for limit Min
                            return false;
                        }
                    }
                    // }
                    ctrl.$render();
                    return !value ? true : regex.test(result);
                } else {
                    return false;
                }
            }
        }
    };
}



function validateTariff() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {

            var regex = new RegExp(/^\d{1,}((\.|,)\d{1,5})?$/);
            var regexNoLetters = /[a-zA-Zа-я-А-Я]/g;
            var re = /^(\d{1,5}[.,]\d{5})[\s\S]*/;

            ctrl.$validators.validateAmount = function(value) {
                if (ctrl.$viewValue == 0) {
                    return false;
                }
                if (value) {

                    var value = value.toString().replace(regexNoLetters, '').replace(',', '.');
                    // var result = value.match(/^\d{1,5}[.,]\d{2}/);
                    var result = value.replace(re, '$1');

                    ctrl.$setValidity('amount', true);
                    ctrl.$setViewValue(result);
                    if (!regex.test(result)) {
                        ctrl.$setTouched();
                    }
                    ctrl.$render();
                    return !value ? true : regex.test(result);
                } else {
                    return false;
                }
            }
        }
    };
}

function validateValue() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {
            var regex = new RegExp(/^\d{1,}((\.|,)\d{1,4})?$/);
            var regexNoLetters = /[a-zA-Zа-я-А-Я]/g;
            var re = /^(\d{1,5}[.,]\d{4})[\s\S]*/;

            ctrl.$validators.validateAmount = function(value) {
                if (ctrl.$viewValue == 0) {
                    return false;
                }
                if (value) {

                    var value = value.toString().replace(regexNoLetters, '').replace(',', '.');
                    var result = value.replace(re, '$1');

                    ctrl.$setValidity('amount', true);
                    ctrl.$setViewValue(result);
                    if (!regex.test(result)) {
                        ctrl.$setTouched();
                    }
                    ctrl.$render();
                    return !value ? true : regex.test(result);
                } else {
                    return false;
                }
            }
        }
    };
}


function validateSubsidy() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {

            var regex = new RegExp(/^\d{1,}((\.|,)\d{1,2})?$/);
            var regexNoLetters = /[a-zA-Zа-я-А-Я]/g;
            var re = /^(\d{1,5}[.,]\d{2})[\s\S]*/;

            ctrl.$validators.validateAmount = function(value) {
                if (value) {

                    var value = value.toString().replace(regexNoLetters, '').replace(',', '.');
                    var result = value.replace(re, '$1');

                    ctrl.$setValidity('amount', true);
                    ctrl.$setViewValue(result);
                    if (!regex.test(result)) {
                        ctrl.$setTouched();
                    }
                    ctrl.$render();
                    return !value ? true : regex.test(result);
                } else {
                    return false;
                }
            }
        }
    };
}




function validateFeedback() {
    var result,
        email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,60}))$/,
        fio = /^[A-zА-яіІїЇґҐєЄ ]{3,60}$/,
        message = /^[A-zА-яіІїЇґҐєЄ \n\d\-\."#№,\)\(\?!:;$%']{10,500}$/;

    function checkRegexp(attrs, el, value) {
        if (attrs.name === 'email') {
            result = email.test(value);
            el.toggleClass('ct-input-invalid', !result);
            return result;
        }

        if (attrs.name === 'message') {
            result = message.test(value);
            el.toggleClass('ct-input-invalid', !result);
            return result;
        }

        if (attrs.name === 'fio') {
            result = fio.test(value);
            el.toggleClass('ct-input-invalid', !result);
            return result;
        }
    }

    return {
        restrict: 'A',
        require: 'ngModel',
        controller: function($scope) {

        },
        link: function(scope, el, attrs, ctrl) {

            ctrl.$validators.validateEmail = function(value) {

                // console.log('ctrl ', ctrl);
                if (!ctrl.$pristine) {
                    return checkRegexp(attrs, el, value);
                } else {
                    return true;
                }
            };
        }
    }

}

function validateCardNumber() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            var regex = /^\d{1,5}(\.|,)?\d{0,2}$/;
            ctrl.$parsers.unshift(function(value) {
                ctrl.$setValidity('validateCardNumber', algorithmMoon(value));

                return value;
            });

            ctrl.$formatters.unshift(function(value) {
                ctrl.$setValidity('validateCardNumber', algorithmMoon(value));

                return value;
            });
        }
    };
}

function validateMonth() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            var regexp = /^(0|1)\d$/;

            ctrl.$parsers.unshift(function(value) {
                var valid = true;

                if (!regexp.test(value) ||
                    parseInt(value, 10) > 12 || parseInt(value, 10) < 0
                ) {
                    valid = false;
                }

                ctrl.$setValidity('validateMonth', valid);
                return value;
            });
        }
    };
}

function validateYear() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            var regexp = /^\d{2}$/;

            ctrl.$parsers.unshift(function(value) {
                var valid = true;
                var nowYear = new Date().getFullYear() - 2000;
                var enterYear = parseInt(value, 10);

                if (!regexp.test(value) ||
                    enterYear < 0 ||
                    enterYear < nowYear
                ) {
                    valid = false;
                }

                ctrl.$setValidity('validateYear', valid);

                return value;
            });
        }
    };
}

function validateLogin() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            var regexp = /^[\dA-z_\.\-@]{6,30}$/;

            ctrl.$parsers.unshift(function(value) {
                var isValid = regexp.test(value);
                ctrl.$setValidity('validateLogin', isValid);
                return value;
            });

            elem.on('input', function() {
                scope.$apply(function() {
                    ctrl.$setViewValue(elem.val());
                    console.log('Input event triggered, value:', elem.val()); // Додано для відслідковування
                });
            });
        }
    };
}

function validateLoginKe() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            var regexp = /^[A-zА-яіІїЇґҐєЄ \-\d_,\. @]{1,40}$/;

            ctrl.$parsers.unshift(function(value) {
                ctrl.$setValidity('validateLogin', regexp.test(value));
                return value;
            });
        }
    };
}

function validatePassword() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {
            var regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d!@#$%^&*()_+\-={}\[\]:;<>,.?])[A-Za-z\d!@#$%^&*()_+\-={}\[\]:;<>,.?]{12,40}$/;

            ctrl.$parsers.unshift(function(value) {
                var valid = regexp.test(value);
                ctrl.$setValidity('validatePassword', valid);
                return valid ? value : undefined;
            });
        }
    };
}

function validateEqual() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            var opt = attr.validateEqual.split(':');

            ctrl.$parsers.unshift(function(value) {
                ctrl.$setValidity('validateEqual', scope[opt[0]][opt[1]] === value);
                return value;
            });
        }
    };
}

function validateSmsCode() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            var regexp = /^[\d]{4}$/;

            ctrl.$parsers.unshift(function(value) {
                ctrl.$setValidity('validateSmsCode', regexp.test(value));
                return value;
            });
        }
    };
}

function validateTitle() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            if(attr['validateTitle'] == "accounts_name"){
                var regexp = /^[A-zА-яіІїЇґҐєЄ )(\-\d№#,\.\"]{1,50}$/;
            }else{
                var regexp = /^[A-zА-яіІїЇґҐєЄ )(\-\d№#,\.]{1,50}$/;
            }
            ctrl.$parsers.unshift(function(value) {
                ctrl.$setValidity('validateTitle', regexp.test(value));
                return value;
            });
        }
    };
}

function validateFio() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            var regexp = /^[A-zА-яіІїЇґҐєЄ ]{3,60}$/;

            ctrl.$parsers.unshift(function(value) {
                ctrl.$setValidity('validateName', regexp.test(value));
                return value;
            });
        }
    };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/validators/validators.directives.js
 ** module id = 242
 ** module chunks = 1
 **/